import {
  CLOSE_ERROR_POPUP,
  GET_SERIES_REPORT_ERROR,
  GET_SERIES_REPORT_REQUEST,
  GET_SERIES_REPORT_SUCCESS,
  GET_EXCEL_FILE_SERIES_ERROR,
  GET_EXCEL_FILE_SERIES_REQUEST,
  GET_EXCEL_FILE_SERIES_SUCCESS,
  GET_SHORT_EXCEL_FILE_SERIES_REQUEST,
  GET_SHORT_EXCEL_FILE_SERIES_SUCCESS,
  GET_SHORT_EXCEL_FILE_SERIES_ERROR,
  POST_UNRESERVE_MARKING_CODES_SERIES_REQUEST,
  POST_UNRESERVE_MARKING_CODES_SERIES_SUCCESS,
  POST_UNRESERVE_MARKING_CODES_SERIES_ERROR,
} from './constants';

export const getSeriesReportRequest = (dates: any) => ({
  type: GET_SERIES_REPORT_REQUEST,
  payload: dates,
});
export const getSeriesReportSuccess = (data: any) => ({
  type: GET_SERIES_REPORT_SUCCESS,
  payload: data,
});
export const getSeriesReportError = (error: any) => ({
  type: GET_SERIES_REPORT_ERROR,
  payload: error,
});
export const getExcelFileSeriesRequest = (body: any) => ({
  type: GET_EXCEL_FILE_SERIES_REQUEST,
  payload: body,
});
export const getShortExcelFileSeriesRequest = (body: any) => ({
  type: GET_SHORT_EXCEL_FILE_SERIES_REQUEST,
  payload: body,
});
export const getExcelFileSeriesSuccess = () => ({
  type: GET_EXCEL_FILE_SERIES_SUCCESS,
});
export const getShortExcelFileSeriesSuccess = () => ({
  type: GET_SHORT_EXCEL_FILE_SERIES_SUCCESS,
});
export const getExcelFileSeriesError = (error: any) => ({
  type: GET_EXCEL_FILE_SERIES_ERROR,
  payload: error,
});
export const getShortExcelFileSeriesError = (error: any) => ({
  type: GET_SHORT_EXCEL_FILE_SERIES_ERROR,
  payload: error,
});

export const postUnreserveMarkingCodesSeriesRequest = (body: any) => ({
  type: POST_UNRESERVE_MARKING_CODES_SERIES_REQUEST,
  payload: body,
});
export const postUnreserveMarkingCodesSeriesSuccess = (response: any) => ({
  type: POST_UNRESERVE_MARKING_CODES_SERIES_SUCCESS,
  payload: response,
});
export const postUnreserveMarkingCodesSeriesError = (error: any) => ({
  type: POST_UNRESERVE_MARKING_CODES_SERIES_ERROR,
  payload: error,
});

export const closeSeriesErrorPopUp = () => ({
  type: CLOSE_ERROR_POPUP,
});

export type Actions =
  | ReturnType<typeof postUnreserveMarkingCodesSeriesRequest>
  | ReturnType<typeof postUnreserveMarkingCodesSeriesSuccess>
  | ReturnType<typeof postUnreserveMarkingCodesSeriesError>
  | ReturnType<typeof closeSeriesErrorPopUp>
  | ReturnType<typeof getSeriesReportRequest>
  | ReturnType<typeof getSeriesReportSuccess>
  | ReturnType<typeof getSeriesReportError>
  | ReturnType<typeof getExcelFileSeriesRequest>
  | ReturnType<typeof getExcelFileSeriesSuccess>
  | ReturnType<typeof getExcelFileSeriesError>
  | ReturnType<typeof getShortExcelFileSeriesRequest>
  | ReturnType<typeof getShortExcelFileSeriesSuccess>
  | ReturnType<typeof getShortExcelFileSeriesError>;
